import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createCategoryRequest = { category: '_enterpriseCategory' };
var _createCategoryResponse = { category: '_enterpriseCategory' };
var _deleteCategoryRequest = {};
var _deleteCategoryResponse = {};
var _enterpriseCategory = {
    sortOrder: 'google.protobuf.FloatValue',
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _enterpriseCategoryTree = {
    category: '_enterpriseCategory',
    subCategories: '_enterpriseCategoryTree',
};
var _enterpriseOnboardingRequest = {};
var _enterpriseOnboardingResponse = { category: '_enterpriseCategory' };
var _getCategoryRequest = {};
var _getCategoryResponse = { category: '_enterpriseCategoryTree' };
var _getMediaManagerCategoriesRequest = {};
var _getMediaManagerCategoriesResponse = {
    category: '_enterpriseCategoryTree',
};
var _linkItemsToCategoryRequest = {};
var _linkItemsToCategoryResponse = {};
var _unlinkItemsFromCategoryRequest = {};
var _unlinkItemsFromCategoryResponse = {};
var _updateCategoryRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    category: '_enterpriseCategory',
};
var _updateCategoryResponse = { category: '_enterpriseCategory' };
function resolveComWixMediaEnterprisePublicMediaV1EnterpriseCategoriesServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/enterprise-public-media-server',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/enterprise-public-media-server',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/enterprise-public-media-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Fetch a list of random media from different providers, using site information to customize results when available */
export function createCategory(payload) {
    var _a = serializer(_createCategoryRequest, { _enterpriseCategory: _enterpriseCategory }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCategoryResponse, {
        _enterpriseCategory: _enterpriseCategory,
    }).fromJSON;
    function __createCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_category',
            method: 'POST',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseCategoriesService.CreateCategory',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseCategoriesServiceUrl({ protoPath: '/v1/enterprise/categories', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCategory.fromReq = fromReq;
    __createCategory.__isAmbassador = true;
    return __createCategory;
}
/** Delete a category including all its subcategories - but not the items */
export function deleteCategory(payload) {
    var _a = serializer(_deleteCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCategoryResponse, {}).fromJSON;
    function __deleteCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_category',
            method: 'DELETE',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseCategoriesService.DeleteCategory',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseCategoriesServiceUrl({
                protoPath: '/v1/enterprise/categories/{categoryId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCategory.fromReq = fromReq;
    __deleteCategory.__isAmbassador = true;
    return __deleteCategory;
}
/** Update category details */
export function updateCategory(payload) {
    var _a = serializer(_updateCategoryRequest, { _enterpriseCategory: _enterpriseCategory }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCategoryResponse, {
        _enterpriseCategory: _enterpriseCategory,
    }).fromJSON;
    function __updateCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_category',
            method: 'PATCH',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseCategoriesService.UpdateCategory',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseCategoriesServiceUrl({
                protoPath: '/v1/enterprise/categories/{category.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCategory.fromReq = fromReq;
    __updateCategory.__isAmbassador = true;
    return __updateCategory;
}
/** Get information about a specific category */
export function getCategory(payload) {
    var _a = serializer(_getCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCategoryResponse, {
        _enterpriseCategory: _enterpriseCategory,
        _enterpriseCategoryTree: _enterpriseCategoryTree,
    }).fromJSON;
    function __getCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_category',
            method: 'GET',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseCategoriesService.GetCategory',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseCategoriesServiceUrl({
                protoPath: '/v1/enterprise/categories/{categoryId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCategory.fromReq = fromReq;
    __getCategory.__isAmbassador = true;
    return __getCategory;
}
/**
 * Create the enterprise category under "enterprise-media" main category
 * the caller identity must be have the same accountId of the request
 */
export function enterpriseOnboarding(payload) {
    var _a = serializer(_enterpriseOnboardingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_enterpriseOnboardingResponse, {
        _enterpriseCategory: _enterpriseCategory,
    }).fromJSON;
    function __enterpriseOnboarding(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_category',
            method: 'POST',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseCategoriesService.EnterpriseOnboarding',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseCategoriesServiceUrl({ protoPath: '/v1/enterprise/onboarding', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __enterpriseOnboarding.fromReq = fromReq;
    __enterpriseOnboarding.__isAmbassador = true;
    return __enterpriseOnboarding;
}
/** link multiple items to the same category */
export function linkItemsToCategory(payload) {
    var _a = serializer(_linkItemsToCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_linkItemsToCategoryResponse, {}).fromJSON;
    function __linkItemsToCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_category',
            method: 'POST',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseCategoriesService.LinkItemsToCategory',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseCategoriesServiceUrl({
                protoPath: '/v1/enterprise/categories/{categoryId}/link-items',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __linkItemsToCategory.fromReq = fromReq;
    __linkItemsToCategory.__isAmbassador = true;
    return __linkItemsToCategory;
}
/** unlink multiple items from a category */
export function unlinkItemsFromCategory(payload) {
    var _a = serializer(_unlinkItemsFromCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unlinkItemsFromCategoryResponse, {}).fromJSON;
    function __unlinkItemsFromCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_category',
            method: 'POST',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseCategoriesService.UnlinkItemsFromCategory',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseCategoriesServiceUrl({
                protoPath: '/v1/enterprise/categories/{categoryId}/unlink-items',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unlinkItemsFromCategory.fromReq = fromReq;
    __unlinkItemsFromCategory.__isAmbassador = true;
    return __unlinkItemsFromCategory;
}
/** Get the account category tree details */
export function getMediaManagerCategories(payload) {
    var _a = serializer(_getMediaManagerCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMediaManagerCategoriesResponse, {
        _enterpriseCategory: _enterpriseCategory,
        _enterpriseCategoryTree: _enterpriseCategoryTree,
    }).fromJSON;
    function __getMediaManagerCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_category',
            method: 'GET',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseCategoriesService.GetMediaManagerCategories',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseCategoriesServiceUrl({
                protoPath: '/v1/enterprise/media-manager/categories',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMediaManagerCategories.fromReq = fromReq;
    __getMediaManagerCategories.__isAmbassador = true;
    return __getMediaManagerCategories;
}
//# sourceMappingURL=http.impl.js.map